import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";

import { FilterModal } from "@src/components/organisms/modals/filter-modal/filter-modal";
import { useNewMachineFilterModalHook } from "@src/components/organisms/modals/filter-modal/use-new-machine-filter-modal-hook";
import styles from "./machine-structure-filter.module.scss";

const cssClassName = "machine-structure-filter-modal";

export const MachineStructureFilter = () => {
  const showFilterModal = useSelector(
    (state: RootState) =>
      state.yourSlice.machineStructureFilterModal.showFilterModal,
  );

  return (
    <>
      {showFilterModal && (
        <div className={styles[cssClassName]}>
          <FilterModal useHook={useNewMachineFilterModalHook} />
        </div>
      )}
    </>
  );
};
